import store from '@/store'
import { watch } from 'vue'
import i18n from '@/i18n'

export const generateTitle = (title) => {
  return i18n.global.t(`msg.route.${title}`)
}

// 处理组件国际化失败的问题
export function watchSwitchLang(...cbs) {
  watch(
    () => store.getters.language,
    () => {
      cbs.forEach(cb => cb(store.getters.language))
    }
  )
}
